import { getTicket, getAccountId, getAccountName } from '@/utils/cookies'
import { queryUserInfo } from '@/api/common'

const state = {
  ticket: getTicket() || '',
  AccountId: getAccountId() || '', // 用户账号
  AccountName: getAccountName() || '', // 用户账号
  account: {} // 用户登录信息
}

const actions = {
  /**
   * 获取用户信息
   * @param commit
   * @constructor
   */
  USER_GET_INFO ({commit}) {
    queryUserInfo()
      .then(result => {
        console.log(result)
        // alert(JSON.stringify(result))
        if (result && result.status === 200) {
          if (result.data.startsWith('(')) {
            result.data = result.data.replace('(', '')
          }
          if (result.data.endsWith(')')) {
            // result.data = result.data.replace(')', '')
            result.data = result.data.substr(0, result.data.length - 1)
          }
          try {
            let tempData = JSON.parse(result.data)
            console.log(tempData)
            commit('SET_USER_ACCOUNTID', tempData.AccountId)
            commit('SET_USER_ACCOUNTNAME', tempData.AccountName)
            commit('SET_USER_ACCOUNT', tempData)
          } catch (e) {
            console.error(`====== 登录信息解析失败：${JSON.stringify(e)}`)
            console.error(`====== 被解析脚本：${result.data}`)
          }
        }
      })
  }
}

const mutations = {
  /**
   * 设置用户id
   * @param state
   * @param id
   * @constructor
   */
  SET_USER_ACCOUNTID (state, id) {
    state.AccountId = id
  },

  /**
   * 设置用户name
   * @param state
   * @param name
   * @constructor
   */
  SET_USER_ACCOUNTNAME (state, name) {
    state.AccountName = name
  },

  /**
   * 存储用户登录信息
   * @param state
   * @param account
   * @constructor
   */
  SET_USER_ACCOUNT (state, account) {
    state.account = {...account}
  }
}

const getters = {
  /**
   * 获取用户登录凭证 tickte
   * @param state
   * @returns {*|string}
   */
  getToken (state) {
    return state.ticket
  },

  /**
   * 获取用户登录账号Id
   * @param state
   * @returns {*|string}
   */
  getAccountId (state) {
    return state.AccountId
  },

  /**
   * 获取用户登录账号name
   * @param state
   * @returns {*|string}
   */
  getAccountName (state) {
    return state.AccountName
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js